module.exports = {"publishedEvents":"Published Events - FR","pastEvents":"Past Events - FR","unpublishedEvents":"Unpublished Events - FR"}


//////////////////
// WEBPACK FOOTER
// ./src/components/EventListing/EventCategory/locales/fr.json
// module id = 1140
// module chunks = 0